import { Stack, Typography } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import InlineAttribute from "../../../../common/InlineAttribute";
import UserWithTimestamp from "../../../../common/UserWithTimestamp";
import InvestorCommunicationContentTile from "./InvestorCommunicationContentTile";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import InvestorCommunicationRecipientsTile from "./InvestorCommunicationRecipientsTile";
import InvestorCommunicationTimingTile from "./InvestorCommunicationTimingTile";

const InvestorCommunicationSettingsSection = () => {
  const { investorCommunication } = useDefinedContext(InvestorCommunicationContext, "InvestorCommunicationContext");

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Stack spacing={0.5} sx={{ pt: 4 }}>
        <Typography variant="subtitle1">Settings</Typography>
        <Typography variant="caption" color="textSecondary">
          Content, audience and email configuration for this update.
        </Typography>
      </Stack>

      <InvestorCommunicationContentTile />

      <InvestorCommunicationRecipientsTile />

      <InvestorCommunicationTimingTile />

      <Stack>
        <InlineAttribute
          label="Created"
          labelWidth="12.5rem"
          value={
            <UserWithTimestamp
              userName={investorCommunication.createdByUserName}
              timestamp={investorCommunication.createdAt}
            />
          }
        />
        <InlineAttribute
          label="Last edited"
          labelWidth="12.5rem"
          value={
            <UserWithTimestamp
              userName={investorCommunication.updatedByUserName}
              timestamp={investorCommunication.updatedAt}
            />
          }
        />
      </Stack>
    </Stack>
  );
};

export default InvestorCommunicationSettingsSection;
